module.exports = __webpack_public_path__ + "static/img/zhifuweixin2.c40cfe2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhifuweixin2.jpg
// module id = HhT8
// module chunks = 4